import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    OnInit
} from '@angular/core';
import {FormControl, FormGroupDirective} from '@angular/forms';
import {ValueLists} from '@common/core/services/value-lists.service';
import {BehaviorSubject} from 'rxjs';
import {CustomDomain} from '@common/custom-domain/custom-domain';
import {Settings} from '@common/core/config/settings.service';

@Component({
    selector: 'domain-form-control',
    templateUrl: './domain-form-control.component.html',
    styleUrls: ['./domain-form-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DomainFormControlComponent implements OnInit, OnChanges {
    @Input() controlName: string;
    @Input() domains: CustomDomain[] = [];
    @Input() hideLabel = false;
    defaultHost$ = new BehaviorSubject<string>(null);
    formControl: FormControl;

    constructor(
        private groupDirective: FormGroupDirective,
        private valueLists: ValueLists,
        private settings: Settings
    ) {}

    ngOnChanges() {
        if (this.domains.length) {
            this.setDefaultHost();
        }
    }

    ngOnInit(): void {
        this.formControl = this.groupDirective.form.controls[
            this.controlName
        ] as FormControl;
    }

    private setDefaultHost() {
        const defaultHost = this.settings.get('custom_domains.default_host');
        if (defaultHost) {
            this.defaultHost$.next(
                this.domains.find(d => d.host === defaultHost).host
            );
        } else {
            const baseUrl = this.settings
                .getBaseUrl()
                .replace(/\/$/, '')
                .replace(/(^\w+:|^)\/\//, '');
            this.defaultHost$.next(baseUrl);
        }
    }
}
